import EvercallRepository from '@/evercall/infrastructure/repository/EvercallRepository';
import createAsyncRequest from '@framework/state/createAsyncRequest';
import { AlertManager } from '@dealroadshow/uikit-alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { getContainer } from '@framework/di/getContainer';
import { TGuestCall } from '@/evercall/domain/vo/call/GuestCall';

interface IProps {
  getCallFormLists: () => Promise<void>,
  setIsInitialized: (payload: boolean) => void,
  setIsSubmitting: (payload: boolean) => void,
  setIsSubmitSucceeded: (payload: boolean) => void,
}

export default (
  {
    getCallFormLists,
    setIsInitialized,
    setIsSubmitting,
    setIsSubmitSucceeded,
  }: IProps,
) => {
  const container = getContainer();
  const evercallRepository: EvercallRepository = container.get(EvercallRepository);

  const initScheduleYourCallForm = () => getCallFormLists().then(() => setIsInitialized(true));

  const submitScheduleYourOaccCallForm = (payload: TGuestCall) => {
    const request = createAsyncRequest<typeof evercallRepository.scheduleOaccCallAsGuest>(
      {
        method: evercallRepository.scheduleOaccCallAsGuest,
        callbacks: {
          onSuccess: () => {
            setIsSubmitting(false);
            setIsSubmitSucceeded(true);
          },
          onError: ({ error }) => {
            setIsSubmitting(false);
            AlertManager.error(getErrorMessage(error));
          },
        },
      },
    );

    setIsSubmitting(true);
    return request(payload);
  };

  const submitScheduleYourWebinarForm = (payload: TGuestCall) => {
    const request = createAsyncRequest<typeof evercallRepository.scheduleWebinarCallAsGuest>(
      {
        method: evercallRepository.scheduleWebinarCallAsGuest,
        callbacks: {
          onSuccess: () => {
            setIsSubmitting(false);
            setIsSubmitSucceeded(true);
          },
          onError: ({ error }) => {
            setIsSubmitting(false);
            AlertManager.error(getErrorMessage(error));
          },
        },
      },
    );

    setIsSubmitting(true);
    return request(payload);
  };

  return {
    initScheduleYourCallForm,
    submitScheduleYourOaccCallForm,
    submitScheduleYourWebinarForm,
  };
};
